import { render } from "./Rating.vue?vue&type=template&id=3fba3a4a"
import script from "./Rating.vue?vue&type=script&lang=js"
export * from "./Rating.vue?vue&type=script&lang=js"

import "./Rating.vue?vue&type=style&index=0&id=3fba3a4a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__